module.exports = __webpack_public_path__ + "img/logo-linkaja_qris-inactive.3eaeaf3d.svg";